<template>
  <div class="mainContainer">
    <h1>Your Score</h1>
    <div
      class="resultsContainer"
      v-for="(score, category) in scores"
      :key="category"
    >
      <h5
        style="margin: 0"
        v-if="Object.keys(scores).length != 1 || category != 'default'"
      >
        {{ category }}
      </h5>
      <h1>{{ score }}</h1>
    </div>
  </div>
</template>

<script>
import pointsStore from "../pointsStore.js";

export default {
  data() {
    return {
      scores: pointsStore.getScore(),
    };
  },
  name: "End",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mainContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.resultsContainer {
  background-color: #ffffff;
  color: #000000;
  font-size: xx-large;
  width: 100%;
  padding: 1rem 2rem;
  border-radius: 1rem;
  margin: 1.5rem;
}
h1 {
  margin: 0;
}
</style>
